// extracted by mini-css-extract-plugin
export default {"SeconderButton":"SeconderButton_SeconderButton__rX9e+","text":"SeconderButton_text__9GSSK"};